// Avis de consentement Loi 25 affiché avant le formulaire d'admission public.
// Reprend le format de l'avis de collecte de parcours (rendu par SimpleMarkdown).
// La version est enregistrée avec la demande pour tracer le consentement.

// La version consentie n'est plus une chaîne portée par le build : le consentement est rattaché
// au PRIVACY_LegalDocuments réellement affiché, servi par /api/Privacy/Document (#115). Le texte
// ci-dessous ne sert plus que de repli si aucun avis n'est publié — cas théorique, le semeur de
// la Fondation publiant un avis au démarrage — pour ne jamais bloquer le formulaire public.

// Étiquette de version du texte intégré ci-dessous : à incrémenter à chaque modification du texte.
// Elle accompagne l'empreinte SHA-256 du texte affiché, que la Fondation exige comme preuve de
// ce que le candidat a vu quand aucun avis n'est publié.
export const ADMISSION_CONSENT_NOTICE_VERSION = 'embedded-1';

/** Empreinte SHA-256 (hexadécimal minuscule) du texte d'avis affiché, encodé en UTF-8. */
export async function hashNoticeText(text: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
}

export const ADMISSION_CONSENT_NOTICE = `# Avis de collecte de renseignements personnels

Conformément à la *Loi sur la protection des renseignements personnels dans le secteur privé* (Loi 25), nous vous informons de ce qui suit avant que vous ne soumettiez votre demande d'admission.

## Finalités de la collecte

Les renseignements que vous fournissez sont recueillis afin de :

- Traiter et évaluer votre demande d'admission;
- Communiquer avec vous au sujet de votre dossier;
- Créer votre dossier d'élève si votre demande est acceptée;
- Respecter les obligations administratives et légales applicables.

## Personnes ayant accès à vos renseignements

Vos renseignements sont consultés uniquement par le personnel autorisé responsable du traitement des admissions.

## Durée de conservation

Vos renseignements sont conservés le temps requis pour le traitement de votre demande et, le cas échéant, pour la constitution de votre dossier d'élève, conformément aux calendriers de conservation applicables.

## Vos droits

Vous avez le droit :

- d'accéder aux renseignements personnels que nous détenons à votre sujet;
- d'en demander la rectification s'ils sont inexacts, incomplets ou équivoques;
- de retirer votre consentement, sous réserve des obligations légales de conservation.

Ces droits s'exercent **auprès du centre de services scolaire** responsable de votre demande d'admission, qui en assure le traitement. Le présent formulaire ne permet pas de les exercer directement.

---

En cochant **« J'ai lu et j'accepte »**, vous reconnaissez avoir pris connaissance de cet avis et consentez à la collecte de vos renseignements aux fins décrites ci-dessus.`;
